import { render, staticRenderFns } from "./CoreNotification.vue?vue&type=template&id=a2d42df6&"
import script from "./CoreNotification.vue?vue&type=script&lang=js&"
export * from "./CoreNotification.vue?vue&type=script&lang=js&"
import style0 from "./CoreNotification.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports